"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormWrapper = void 0;

var react_1 = __importDefault(require("react"));

var rc_tooltip_1 = __importDefault(require("rc-tooltip"));

var lodash_1 = require("lodash");

var fclasses_1 = require("@bodiless/fclasses");

var core_1 = require("@bodiless/core");

var ui_1 = require("@bodiless/ui");

var ReactTags_1 = __importDefault(require("./ReactTags")); // Stacked toolbar orientation...
// Horizontal


var toolbarClasses = 'bl-flex';
var groupClasses = 'bl-border-l first:bl-border-l-0 bl-border-white bl-px-3'; // Vertical
// const toolbarClasses = '';
// eslint-disable-next-line max-len
// const groupClasses = 'bl-border-t first:bl-border-t-0 bl-border-white bl-mt-grid-2 first:bl-mt-grid-0';
// For accessibility attributes, see https://www.w3.org/TR/wai-aria-practices/examples/toolbar/toolbar.html

var Toolbar = lodash_1.flow(fclasses_1.addClasses(toolbarClasses), fclasses_1.addProps({
  role: 'toolbar',
  'aria-label': 'Local Context Menu'
}))(ui_1.Div);

var LocalTooltip = function LocalTooltip(props) {
  return react_1.default.createElement(rc_tooltip_1.default, __assign({}, props, {
    placement: "bottomLeft"
  }));
};

var GroupTitle = lodash_1.flow(fclasses_1.removeClasses('bl-mb-grid-2 bl-min-w-xl-grid-1'))(ui_1.ComponentFormTitle);

var ContextMenuGroup = function ContextMenuGroup(_a) {
  var option = _a.option,
      children = _a.children;
  var hidden = Boolean(option && (typeof option.isHidden === 'function' ? option.isHidden() : option.isHidden));
  if (hidden) return null;
  return react_1.default.createElement("div", {
    className: groupClasses
  }, option && option.label && react_1.default.createElement(GroupTitle, null, option.label), react_1.default.createElement("div", {
    className: "flex"
  }, children));
};

exports.FormWrapper = fclasses_1.addClasses('bl-flex')(ui_1.Div);
var ui = {
  ComponentFormText: ui_1.ComponentFormText,
  ComponentFormTextArea: ui_1.ComponentFormTextArea,
  ComponentFormFieldWrapper: ui_1.ComponentFormFieldWrapper,
  ComponentFormFieldTitle: ui_1.ComponentFormFieldTitle,
  ComponentFormCheckBox: ui_1.ComponentFormCheckBox,
  ComponentFormRadio: ui_1.ComponentFormRadio,
  ComponentFormRadioGroup: ui_1.ComponentFormRadioGroup,
  ComponentFormSelect: ui_1.ComponentFormSelect,
  ComponentFormOption: ui_1.ComponentFormOption,
  ComponentFormButton: ui_1.ComponentFormButton,
  ComponentFormCloseButton: ui_1.ComponentFormCloseButton,
  ComponentFormUnwrapButton: ui_1.ComponentFormUnwrapButton,
  ComponentFormSubmitButton: ui_1.ComponentFormSubmitButton,
  ComponentFormTitle: ui_1.ComponentFormTitle,
  ComponentFormLabel: ui_1.ComponentFormLabel,
  ComponentFormDescription: ui_1.ComponentFormDescription,
  ContextSubMenu: ui_1.ContextSubMenu,
  ComponentFormWarning: ui_1.ComponentFormWarning,
  Icon: ui_1.ToolbarIcon,
  Toolbar: Toolbar,
  ToolbarButton: ui_1.HorizontalToolbarButton,
  ToolbarButtonLabel: ui_1.ToolbarButtonLabel,
  FormWrapper: exports.FormWrapper,
  Tooltip: LocalTooltip,
  ReactTags: ReactTags_1.default,
  ContextMenuGroup: ContextMenuGroup
};

var LocalContextMenu = function LocalContextMenu(props) {
  return react_1.default.createElement(core_1.ContextMenu, __assign({}, props, {
    ui: ui
  }));
};

exports.default = LocalContextMenu;